// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pencil-solid';

export const Component = () => (
  <path d='m21.2 8.269-1.055 1.054-4.837-4.838 1.054-1.054C16.6 3.144 16.937 3 17.367 3c.48 0 .814.144 1.054.431L21.2 6.21c.288.24.431.575.431 1.054 0 .48-.143.814-.43 1.006ZM3.43 16.363 14.59 5.155l4.885 4.838L8.268 21.2c-.191.288-.527.431-1.006.431H3.959a.946.946 0 0 1-.67-.287.976.976 0 0 1-.288-.719v-3.257c0-.431.144-.766.431-1.005Z' />
);

export const viewBox = '0 0 25 25';
